import { Injectable } from '@angular/core';
import { ImageMetaData } from '@shared/components/feed-image-modal/feed-image-modal.component';
import { StaticCanvas } from 'fabric/fabric-impl';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FeedImageModalService {
    private canvasSource$ = new Subject<StaticCanvas>();
    private imageIdSource$ = new Subject<number>();
    private imageSource$ = new Subject<ImageMetaData>();

    canvas$ = this.canvasSource$.asObservable();
    imageId$ = this.imageIdSource$.asObservable();
    image$ = this.imageSource$.asObservable();

    constructor() { }

    setCanvas(canvas: StaticCanvas) {
        this.canvasSource$.next(canvas);
    }
    setImageId(id: number) {
        this.imageIdSource$.next(id);
    }

    setImage(im: ImageMetaData) {
        this.imageSource$.next(im)
    }


}
